import { render, staticRenderFns } from "./vue-qz-tray-options.vue?vue&type=template&id=5a23f660&scoped=true&"
import script from "./vue-qz-tray-options.vue?vue&type=script&lang=js&"
export * from "./vue-qz-tray-options.vue?vue&type=script&lang=js&"
import style0 from "./vue-qz-tray-options.vue?vue&type=style&index=0&id=5a23f660&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a23f660",
  null
  
)

export default component.exports